module.exports = __webpack_public_path__ + "img/icon_editar_responsable.a6c0eb2e.svg";